<template>
  <div v-if="show" class="odp_model">
    <template v-for="(item, index) in table">
      <o-vData
        v-if="item['data']"
        :key="`data-${index}`"
        :lineIndex="index"
        :lineData="item"
        :func_input="inputChange"
        :func_click="func_SPEC_S"
      />
      <o-vDataMulti
        v-else-if="item['data_multi']"
        :key="`multi-${index}`"
        :lineIndex="index"
        :lineData="item"
        :func_input="inputChange"
        :func_click="func_SPEC_S"
      />
      <o-vDataAfter
        v-else-if="item['data_after']"
        :key="`after-${index}`"
        :lineIndex="index"
        :lineData="item"
        :func_input="inputChange"
        :func_click="func_SPEC_S"
      />
    </template>
  </div>
</template>
<script>
import { gain_produce } from "@/seal/proEnvelopes";
import iconv from "iconv-lite";

export default {
  name: "xinfeng",
  props: {},
  data() {
    return {
      pidd: "pidenv_xf",
      pid: "pidenv_xf",
      show: false,
      table: {},
    };
  },
  methods: {
    showChange() {
      // 获取表单
      const produce = gain_produce(this["pid"]);
      if (produce["table"]) {
        this.table = produce["table"];
      } else {
        return;
      }
      this.show = true;
    },
    closeChange() {
      this.show = false;
    },
    //输入框完成事件
    inputChange(event) {
      const params = this.func_tidyParams();
      this.$parent.func_quotation(this.pidd, params);
    },
    //点击产品规格-汇总
    func_SPEC_S(event) {
      const type = event.currentTarget.dataset.type;
      const index = event.currentTarget.dataset.index;
      const seq = event.currentTarget.dataset.seq;
      if (!this.table[index] || !this.table[index][type]) return;
      switch (type) {
        case "data": {
          //当前点击行的所有参数规格
          let data = this.table[index][type];
          if (data[seq]["choose"] && data[seq]["type"] !== "select"){
            return;
          } 
          // 点击区域属-'下拉框'
          if (data[seq]["type"] === "select") {
            const select_index = event.currentTarget.dataset.select_index;
            if (select_index) {
              data[seq]["name"] =
                data[seq]["select_data"][select_index]["name"];
              data[seq]["value"] =
                data[seq]["select_data"][select_index]["value"];
            }
          }
          //切换已选中的'下拉框'的内容时-不需要执行
          if (!data[seq]["choose"]) {
            for (let i in data) {
              if (data[i]["choose"]) {
                data[i]["choose"] = false;
                data[seq]["choose"] = true;
                break;
              }
            }
          }
          // 另行处理
          if(data[seq]['name'] === '西式开窗'){
            // 检查是否已经存在开窗贴膜
            let hasWindowFilm = false;
            for (let i = 0; i < this.table.p_houdaogongxu.data_after.length; i++) {
              if (this.table.p_houdaogongxu.data_after[i].data && 
                  this.table.p_houdaogongxu.data_after[i].data[0] && 
                  this.table.p_houdaogongxu.data_after[i].data[0].name && 
                  this.table.p_houdaogongxu.data_after[i].data[0].name.indexOf('开窗贴膜') >= 0) {
                hasWindowFilm = true;
                break;
              }
            }
            
            // 如果不存在才添加
            if (!hasWindowFilm) {
              this.table.p_houdaogongxu.data_after.push({
                container: ["jpx", "jpy", "jpHd", "jpCl", 'hjg'],
                must: false,
                data: [
                  {
                    type: "select",
                    custom2: true,
                    unit: "mm",
                    name: "开窗贴膜-信封专用(4丝)",
                    value: [90, 50, "0.04", 12, '开天窗贴胶片'],
                    choose: true,
                    select_show: false,
                    select_data: [
                      { name: "开窗贴膜-信封专用(4丝)", value: [90, 50, "0.04", 12, '开天窗贴胶片'] },
                      { name: "开窗贴膜-加厚(8丝)", value: [90, 50, "0.08", 12, '开天窗贴胶片'] },
                      { name: "开窗贴膜-加厚(12丝)", value: [90, 50, "0.12", 12, '开天窗贴胶片'] },
                    ],
                  },
                ],
              });
            }
          } else if(data[seq]['name'] === '自定义展开尺寸') {
            // 检查是否已经存在开窗贴膜
            let hasWindowFilm = false;
            for (let i = 0; i < this.table.p_houdaogongxu.data_after.length; i++) {
              if (this.table.p_houdaogongxu.data_after[i].data && 
                  this.table.p_houdaogongxu.data_after[i].data[0] && 
                  this.table.p_houdaogongxu.data_after[i].data[0].name && 
                  this.table.p_houdaogongxu.data_after[i].data[0].name.indexOf('开窗贴膜') >= 0) {
                hasWindowFilm = true;
                break;
              }
            }
            // 如果不存在,并且尺寸不为自定义
            if (!hasWindowFilm) {
              this.table.p_houdaogongxu.data_after.push({
                container: ["jpx", "jpy", "jpHd", "jpCl", 'hjg'],
                must: false,
                data: [
                  {
                    type: "select",
                    custom2: true,
                    unit: "mm",
                    name: "开窗贴膜-信封专用(4丝)",
                    value: [90, 50, "0.04", 12, '开天窗贴胶片'],
                    choose: false,
                    select_show: false,
                    select_data: [
                      { name: "开窗贴膜-信封专用(4丝)", value: [90, 50, "0.04", 12, '开天窗贴胶片'] },
                      { name: "开窗贴膜-加厚(8丝)", value: [90, 50, "0.08", 12, '开天窗贴胶片'] },
                      { name: "开窗贴膜-加厚(12丝)", value: [90, 50, "0.12", 12, '开天窗贴胶片'] },
                    ],
                  },
                ],
              });
            }
          } else if (this.table.p_chengpinchicun.data[0].choose){
            // 检查是否是八号信封且选中西式开窗
            const is8haoXinfeng = this.table.p_chengpinchicun.data[0].name.indexOf('8号信封') >= 0;
            const isXishiKaichuang = this.table.p_xinfeng.data && this.table.p_xinfeng.data.some(item => 
              item.name === '西式开窗' && item.choose
            );
            
            // 如果是八号信封且选中西式开窗，则不删除开窗贴膜
            if (!(is8haoXinfeng && isXishiKaichuang)) {
              // 移除开窗贴膜（如果存在）
              for (let i = this.table.p_houdaogongxu.data_after.length - 1; i >= 0; i--) {
                if (this.table.p_houdaogongxu.data_after[i].data && 
                    this.table.p_houdaogongxu.data_after[i].data[0] && 
                    this.table.p_houdaogongxu.data_after[i].data[0].name && 
                    this.table.p_houdaogongxu.data_after[i].data[0].name.indexOf('开窗贴膜') >= 0) {
                  this.table.p_houdaogongxu.data_after.splice(i, 1);
                }
              }
            }
          }
          if (
            data[seq]["name"] === "西式" &&
            this.table["p_chengpinchicun"]["data"][0].choose &&
            (this.table["p_chengpinchicun"]["data"][0].name.indexOf(
              "1号信封"
            ) >= 0 ||
              this.table["p_chengpinchicun"]["data"][0].name.indexOf(
                "2号信封"
              ) >= 0)
          ) {
            this.table["p_daomo"]["data"] = [
              { type: "default", name: "定制刀模", value: "1", choose: true },
            ];
            let hasDaJiYan = false;
            for (let i = 0; i < this.table.p_houdaogongxu.data_after.length; i++) {
              if (this.table.p_houdaogongxu.data_after[i].data && 
                  this.table.p_houdaogongxu.data_after[i].data[0] && 
                  this.table.p_houdaogongxu.data_after[i].data[0].name === '打鸡眼') {
                hasDaJiYan = true;
                break;
              }
            }
            if (!hasDaJiYan) {
              this.table.p_houdaogongxu.data_after.push({
                container: 'hjg',
                must: false,
                data: [
                  { type: 'default', name: '打鸡眼', value: '打鸡眼', choose: false },
                ]
              });
            }
          }else if(data[seq]["name"] !== "西式" &&
            this.table["p_chengpinchicun"]["data"][0].choose &&
            (this.table["p_chengpinchicun"]["data"][0].name.indexOf(
              "1号信封"
            ) >= 0 ||
              this.table["p_chengpinchicun"]["data"][0].name.indexOf(
                "2号信封"
              ) >= 0)
              // && this.table["p_xinfeng"]["data"] && this.table["p_xinfeng"]["data"].some(item => 
              //   item.name !== '西式' && item.choose
              // )
        ){
          console.log('11111')
          this.table["p_daomo"]["data"] = [
              { type: "default", name: "标准刀模", value: "0", choose: true },
            ];
        }
          if (
            data[seq]["name"] === "定制刀模" ||
            data[seq]["name"] === "自定义展开尺寸"
          ) {
            this.table["p_xinfeng"]["container"] = "xfys";
            this.table["p_daomo"]["data"] = [
              { type: "default", name: "定制刀模", value: "1", choose: true },
            ];
            // 添加打鸡眼工序
            let hasDaJiYan = false;
            for (let i = 0; i < this.table.p_houdaogongxu.data_after.length; i++) {
              if (this.table.p_houdaogongxu.data_after[i].data && 
                  this.table.p_houdaogongxu.data_after[i].data[0] && 
                  this.table.p_houdaogongxu.data_after[i].data[0].name === '打鸡眼') {
                hasDaJiYan = true;
                break;
              }
            }
            if (!hasDaJiYan) {
              this.table.p_houdaogongxu.data_after.push({
                container: 'hjg',
                must: false,
                data: [
                  { type: 'default', name: '打鸡眼', value: '打鸡眼', choose: false },
                ]
              });
            }            this.table["p_xinfeng"]["data"] = [
              { type: "default", name: "中式", value: "中式", choose: true },
              { type: "default", name: "西式", value: "西式", choose: false },
              { type: "default", name: "西式尖舌带插口", value: "西式", choose: false },
            ];
            this.table["p_cailiao"] = {
              name: "材料",
              container: ["cailiao", "yongzhi"],
              data_multi: [
                {
                  type: "select",
                  name: "双胶纸",
                  value: "5",
                  choose: true,
                  level: "1",
                  select_show: false,
                  select_data: [
                    { name: "双铜纸", value: "1" },
                    { name: "单铜纸(白卡)", value: "2" },
                    { name: "哑粉纸", value: "3" },
                    { name: "双胶纸", value: "5" },
                    { name: "黄牛皮", value: "9" },
                    { name: "白牛皮", value: "14" },
                    { name: "冰白珠光纸", value: "13" },
                  ],
                },
                {
                  type: "select",
                  name: "120克",
                  value: 120,
                  choose: true,
                  level: "2",
                  select_show: false,
                  select_data: [
                    { name: "100克", value: 100 },
                    { name: "120克", value: 120 },
                    { name: "140克", value: 140 },
                    { name: "160克", value: 160 },
                    { name: "200克", value: 200 },
                    { name: "250克", value: 250 },
                  ],
                },
              ],
              multi_list: [
                // 双铜纸
                [
                  { name: "105克", value: 105 },
                  { name: "128克", value: 128 },
                  { name: "157克", value: 157 },
                  { name: "200克", value: 200 },
                  { name: "250克", value: 250 },
                  { name: "300克", value: 300 },
                  { name: "350克", value: 350 },
                ],
                // 单铜纸
                [
                  { name: "210克", value: 210 },
                  { name: "250克", value: 250 },
                  { name: "300克", value: 300 },
                  { name: "350克", value: 350 },
                ],
                // 哑粉纸
                [
                  { name: "105克", value: 105 },
                  { name: "128克", value: 128 },
                  { name: "157克", value: 157 },
                  { name: "200克", value: 200 },
                  { name: "250克", value: 250 },
                  { name: "300克", value: 300 },
                ],
                // 双胶纸
                [
                  { name: "100克", value: 100 },
                  { name: "120克", value: 120 },
                  { name: "140克", value: 140 },
                  { name: "160克", value: 160 },
                  { name: "200克", value: 200 },
                  { name: "250克", value: 250 },
                ],
                // 黄牛皮
                [
                  { name: "80克", value: 80 },
                  { name: "100克", value: 100 },
                  { name: "120克", value: 120 },
                  { name: "150克", value: 150 },
                  { name: "180克", value: 180 },
                  { name: "200克", value: 200 },
                  { name: "250克", value: 250 },
                  { name: "300克", value: 300 },
                  { name: "310克", value: 310 },
                  { name: "350克", value: 350 },
                  { name: "360克", value: 360 },
                  { name: "400克", value: 400 },
                  { name: "410克", value: 410 },
                  { name: "450克", value: 450 },
                ],
                // 白牛皮
                [
                  { name: "100克", value: 100 },
                  { name: "120克", value: 120 },
                  { name: "150克", value: 150 },
                  { name: "180克", value: 180 },
                  { name: "200克", value: 200 },
                  { name: "230克", value: 230 },
                  { name: "250克", value: 250 },
                  { name: "300克", value: 300 },
                ],
                // 冰白珠光纸
                [
                  { name: "120克", value: 120 },
                  { name: "140克", value: 140 },
                  { name: "160克", value: 160 },
                  { name: "200克", value: 200 },
                  { name: "250克", value: 250 },
                  { name: "300克", value: 300 },
                  { name: "350克", value: 350 },
                ],
              ],
            };
            const hougong = this.houdaogongxu(5);
            this.table["p_houdaogongxu"] = hougong;
          } else if (
            data[seq]["name"] === "标准刀模" ||
            data[seq]["name"].indexOf("信封") >= 0
          ) {
            this.table["p_daomo"]["data"] = [
              { type: "default", name: "标准刀模", value: "0", choose: true },
            ];
            // 删除打鸡眼工序
            for (let i = this.table.p_houdaogongxu.data_after.length - 1; i >= 0; i--) {
              if (this.table.p_houdaogongxu.data_after[i].data && 
                  this.table.p_houdaogongxu.data_after[i].data[0] && 
                  this.table.p_houdaogongxu.data_after[i].data[0].name === '打鸡眼') {
                this.table.p_houdaogongxu.data_after.splice(i, 1);
              }
            }
            this.table["p_chengpinchicun"]["data"][0].choose = true;
            this.table["p_chengpinchicun"]["data"][1].choose = false;
            if (
              data[seq]["name"].indexOf("1号信封") >= 0 ||
              data[seq]["name"].indexOf("2号信封") >= 0
            ) {
              this.table["p_xinfeng"]["data"] = [
                { type: "default", name: "中式", value: "中式", choose: true },
                { type: "default", name: "西式尖舌带插口", value: "中式", choose: false },
              ];
            } else if (
              data[seq]["name"].indexOf("3号信封") >= 0 ||
              data[seq]["name"].indexOf("5号信封") >= 0 ||
              data[seq]["name"].indexOf("6号信封") >= 0 ||
              data[seq]["name"].indexOf("7号信封") >= 0
            ) {
              this.table["p_xinfeng"]["data"] = [
                { type: "default", name: "中式", value: "中式", choose: true },
                {
                  type: "default",
                  name: "西式平舌",
                  value: "西式",
                  choose: false,
                },
                {
                  type: "default",
                  name: "西式尖舌",
                  value: "西式",
                  choose: false,
                },
                { type: "default", name: "西式尖舌带插口", value: "西式", choose: false },
              ];
            } else if (data[seq]["name"].indexOf("8号信封") >= 0) {
              this.table["p_xinfeng"]["data"] = [
                { type: "default", name: "中式", value: "中式", choose: true },
                {
                  type: "default",
                  name: "西式平舌",
                  value: "西式",
                  choose: false,
                },
                {
                  type: "default",
                  name: "西式开窗",
                  value: "西式开窗",
                  choose: false,
                },
                { type: "default", name: "西式尖舌带插口", value: "西式", choose: false },
              ];
            } else if (data[seq]["name"].indexOf("9号信封") >= 0) {
              this.table["p_xinfeng"]["data"] = [
                { type: "default", name: "中式", value: "中式", choose: true },
                { type: "default", name: "边封", value: "中式", choose: false },
                {
                  type: "default",
                  name: "西式平舌",
                  value: "西式",
                  choose: false,
                },
                { type: "default", name: "西式尖舌带插口", value: "西式", choose: false },
              ];
            } else if (
              data[seq]["name"].indexOf("标准刀模") >= 0 &&
              this.table["p_chengpinchicun"]["data"][0].choose &&
              (this.table["p_chengpinchicun"]["data"][0].name.indexOf(
                "2号信封"
              ) >= 0 ||
                this.table["p_chengpinchicun"]["data"][0].name.indexOf(
                  "1号信封"
                ) >= 0)
            ) {
              this.table["p_xinfeng"]["data"] = [
                { type: "default", name: "中式", value: "中式", choose: true },
                { type: "default", name: "西式尖舌带插口", value: "西式", choose: false },
              ];
            } else if (
              data[seq]["name"].indexOf("标准刀模") >= 0 &&
              this.table["p_chengpinchicun"]["data"][0].choose &&
              this.table["p_chengpinchicun"]["data"][0].name.indexOf(
                "2号信封"
              ) < 0 &&
              this.table["p_chengpinchicun"]["data"][0].name.indexOf(
                "1号信封"
              ) < 0 &&
              this.table["p_chengpinchicun"]["data"][0].name.indexOf(
                "9号信封"
              ) < 0 &&
              this.table["p_chengpinchicun"]["data"][0].name.indexOf(
                "8号信封"
              ) < 0
            ) {
              this.table["p_xinfeng"]["data"] = [
                { type: "default", name: "中式", value: "中式", choose: true },
                {
                  type: "default",
                  name: "西式平舌",
                  value: "西式",
                  choose: false,
                },
                {
                  type: "default",
                  name: "西式尖舌",
                  value: "西式",
                  choose: false,
                },
                { type: "default", name: "西式尖舌带插口", value: "西式", choose: false },
              ];
            } else if (
              data[seq]["name"].indexOf("标准刀模") >= 0 &&
              this.table["p_chengpinchicun"]["data"][0].choose &&
              this.table["p_chengpinchicun"]["data"][0].name.indexOf(
                "9号信封"
              ) >= 0
            ) {
              this.table["p_xinfeng"]["data"] = [
                { type: "default", name: "中式", value: "中式", choose: true },
                {
                  type: "default",
                  name: "西式平舌",
                  value: "西式",
                  choose: false,
                },
                { type: "default", name: "西式尖舌带插口", value: "西式", choose: false },
              ];
            } else if (
              data[seq]["name"].indexOf("标准刀模") >= 0 &&
              this.table["p_chengpinchicun"]["data"][0].choose &&
              this.table["p_chengpinchicun"]["data"][0].name.indexOf(
                "8号信封"
              ) >= 0
            ) {
              this.table["p_xinfeng"]["data"] = [
                { type: "default", name: "中式", value: "中式", choose: true },
                {
                  type: "default",
                  name: "西式平舌",
                  value: "西式",
                  choose: false,
                },
                // {
                //   type: "default",
                //   name: "西式尖舌",
                //   value: "西式",
                //   choose: false,
                // },
                {
                  type: "default",
                  name: "西式开窗",
                  value: "西式开窗",
                  choose: false,
                },
                { type: "default", name: "西式尖舌带插口", value: "西式", choose: false },
              ];
            }
            this.table["p_cailiao"] = {
              name: "材料",
              container: ["cailiao", "yongzhi"],
              data_multi: [
                {
                  type: "select",
                  name: "双胶纸",
                  value: "5",
                  choose: true,
                  level: "1",
                  select_show: false,
                  select_data: [
                    { name: "双胶纸", value: "5" },
                    { name: "黄牛皮", value: "9" },
                    { name: "白牛皮", value: "14" },
                    { name: "双铜纸", value: "1" },
                    { name: "单铜纸(白卡)", value: "2" },
                    { name: "哑粉纸", value: "3" },
                    { name: "冰白珠光纸", value: "13" },
                  ],
                },
                {
                  type: "select",
                  name: "120克",
                  value: 120,
                  choose: true,
                  level: "2",
                  select_show: false,
                  select_data: [
                    { name: "100克", value: 100 },
                    { name: "120克", value: 120 },
                    { name: "140克", value: 140 },
                    { name: "160克", value: 160 },
                    { name: "200克", value: 200 },
                    { name: "250克", value: 250 },
                  ],
                },
              ],
              multi_list: [
                // 双胶纸
                [
                  { name: "100克", value: 100 },
                  { name: "120克", value: 120 },
                  { name: "140克", value: 140 },
                  { name: "160克", value: 160 },
                  { name: "200克", value: 200 },
                  { name: "250克", value: 250 },
                ],
                // 黄牛皮
                [
                  { name: "80克", value: 80 },
                  { name: "100克", value: 100 },
                  { name: "120克", value: 120 },
                  { name: "150克", value: 150 },
                  { name: "180克", value: 180 },
                  { name: "200克", value: 200 },
                  { name: "250克", value: 250 },
                  { name: "300克", value: 300 },
                  { name: "310克", value: 310 },
                  { name: "350克", value: 350 },
                  { name: "360克", value: 360 },
                  { name: "400克", value: 400 },
                  { name: "410克", value: 410 },
                  { name: "450克", value: 450 },
                ],
                // 白牛皮
                [
                  { name: "100克", value: 100 },
                  { name: "120克", value: 120 },
                  { name: "150克", value: 150 },
                  { name: "180克", value: 180 },
                  { name: "200克", value: 200 },
                  { name: "230克", value: 230 },
                  { name: "250克", value: 250 },
                  { name: "300克", value: 300 },
                ],
                // 双铜纸
                [
                  { name: "105克", value: 105 },
                  { name: "128克", value: 128 },
                  { name: "157克", value: 157 },
                  { name: "200克", value: 200 },
                  { name: "250克", value: 250 },
                  { name: "300克", value: 300 },
                  { name: "350克", value: 350 },
                ],
                // 单铜纸
                [
                  { name: "210克", value: 210 },
                  { name: "250克", value: 250 },
                  { name: "300克", value: 300 },
                  { name: "350克", value: 350 },
                ],
                // 哑粉纸
                [
                  { name: "105克", value: 105 },
                  { name: "128克", value: 128 },
                  { name: "157克", value: 157 },
                  { name: "200克", value: 200 },
                  { name: "250克", value: 250 },
                  { name: "300克", value: 300 },
                ],
                // 冰白珠光纸
                [
                  { name: "120克", value: 120 },
                  { name: "140克", value: 140 },
                  { name: "160克", value: 160 },
                  { name: "200克", value: 200 },
                  { name: "250克", value: 250 },
                  { name: "300克", value: 300 },
                  { name: "350克", value: 350 },
                ],
              ],
            };
            this.table["p_houdaogongxu"] = this.houdaogongxu(1);
          }
          break;
        }
        case "data_multi": {
          const level = event.currentTarget.dataset.level;
          const select_index = event.currentTarget.dataset.select_index;
          let data = this.table[index][type];
          if (!level) return;
          data[seq]["name"] = data[seq]["select_data"][select_index]["name"];
          data[seq]["value"] = data[seq]["select_data"][select_index]["value"];
          if (level === "1") {
            // 切换二级内容
            if (
              data[seq]["name"] === "双铜纸" ||
              data[seq]["name"] === "黄牛皮"
            ) {
              data[1]["select_data"] =
                this.table[index]["multi_list"][select_index];
              data[1]["name"] = data[1]["select_data"][2]["name"];
              data[1]["value"] = data[1]["select_data"][2]["value"];
            } else {
              data[1]["select_data"] =
                this.table[index]["multi_list"][select_index];
              data[1]["name"] = data[1]["select_data"][1]["name"];
              data[1]["value"] = data[1]["select_data"][1]["value"];
            }
          }
          if (this.table["p_daomo"]["data"][0].name.indexOf("标准刀模") >= 0) {
            if (
              data[seq]["name"] === "双胶纸" ||
              data[seq]["name"] === "黄牛皮" ||
              data[seq]["name"] === "白牛皮"
            ) {
              const hougong = this.houdaogongxu(1);
              this.table["p_houdaogongxu"] = hougong;
            } else if (data[seq]["name"] === "冰白珠光纸") {
              const hougong = this.houdaogongxu(3);
              this.table["p_houdaogongxu"] = hougong;
            } else if (
              data[seq]["name"] === "双铜纸" ||
              data[seq]["name"] === "单铜纸(白卡)" ||
              data[seq]["name"] === "哑粉纸"
            ) {
              const hougong = this.houdaogongxu(2);
              this.table["p_houdaogongxu"] = hougong;
            }
          } else if (this.table["p_daomo"]["data"][0].name.indexOf("定制刀模") >= 0) {
            if (
              data[seq]["name"] === "双胶纸" ||
              data[seq]["name"] === "黄牛皮" ||
              data[seq]["name"] === "白牛皮"
            ) {
              const hougong = this.houdaogongxu(4);
              this.table["p_houdaogongxu"] = hougong;
            } else {
              const hougong = this.houdaogongxu(5);
              this.table["p_houdaogongxu"] = hougong;
            }
          }
          break;
        }
        case "data_after": {
          const se = event.currentTarget.dataset.se;
          const select_index = event.currentTarget.dataset.select_index;
          let data = this.table[index][type];
          if (data[seq]["data"][se].name == "添加烫金版") {
            this.table.p_houdaogongxu.data_after.push({
              container: ["tjx1", "tjy1", "tangCl1"],
              must: false,
              data: [
                {
                  type: "select",
                  custom2: true,
                  unit: "mm",
                  name: "普通烫金版、烫普通金料",
                  value: [90, 50, "25552"],
                  choose: true,
                  select_show: false,
                  select_data: [
                    {
                      name: "普通烫金版、烫普通金料",
                      value: [90, 50, "25552"],
                    },
                    {
                      name: "加厚烫金版、烫普通金料",
                      value: [90, 50, "25554"],
                    },
                    {
                      name: "浮雕烫金版、烫普通金料",
                      value: [90, 50, "25551"],
                    },
                    {
                      name: "普通烫金版、烫镭射金料",
                      value: [90, 50, "25553"],
                    },
                    {
                      name: "加厚烫金版、烫镭射金料",
                      value: [90, 50, "25550"],
                    },
                    {
                      name: "浮雕烫金版、烫镭射金料",
                      value: [90, 50, "27071"],
                    },
                  ],
                },
              ],
            });
            this.table.p_houdaogongxu.data_after.push({
              container: "TJTB2",
              must: false,
              data: [
                {
                  type: "select",
                  name: "与A同版",
                  value: "0",
                  choose: true,
                  select_show: false,
                  select_data: [
                    { name: "与A同版", value: 0 },
                    { name: "与A不同版", value: 1 },
                  ],
                },
              ],
            });
          }
          if (data[seq]["must"] && data[seq]["data"][se]["choose"]) return;
          let in_data = data[seq]["data"];
          if (select_index !== undefined) {
            in_data[se]["name"] =
              in_data[se]["select_data"][select_index]["name"];
            in_data[se]["value"] =
              in_data[se]["select_data"][select_index]["value"];
          }
          if (data[seq]["must"]) {
            // 当前行为-必选
            for (let i in in_data) {
              if (in_data[i]["choose"]) {
                in_data[i]["choose"] = false;
                in_data[se]["choose"] = true;
                break;
              }
            }
          } else {
            // 当前行为-非必选
            if (in_data[se]["choose"] && select_index === undefined) {
              in_data[se]["choose"] = false;
            } else {
              for (let i in in_data) {
                if (in_data[i]["choose"]) {
                  in_data[i]["choose"] = false;
                  break;
                }
              }
              in_data[se]["choose"] = true;
            }
          }
          if (
            data[seq].data[0].choose &&
            (data[seq].data[0].name == "普通平烫" ||
              data[seq].data[0].name == "浮雕烫")
          ) {
            for (let i in data) {
              if (data[i].container == "tjys") {
                data[i].data[0].choose = true;
              }
            }
          } else if (
            !data[seq].data[0].choose &&
            (data[seq].data[0].name == "普通平烫" ||
              data[seq].data[0].name == "浮雕烫")
          ) {
            for (let i in data) {
              if (data[i].container == "tjys") {
                data[i].data[0].choose = false;
              }
            }
          }
          if (data[seq].data[0].choose && data[seq].data[0].value == "烫金") {
            for (let i in data) {
              if (data[i].container[0] == "tjx") {
                data[i].data[0].choose = true;
              }
            }
          } else if (
            !data[seq].data[0].choose &&
            data[seq].data[0].value == "烫金"
          ) {
            for (let i in data) {
              if (data[i].container[0] == "tjx") {
                data[i].data[0].choose = false;
              }
            }
          }
          break;
        }
        default: {
          return;
        }
      }
      // 整合规格参数，请求报价
      const params = this.func_tidyParams();
      this.$parent.func_quotation(this.pidd, params);
    },
    houdaogongxu(id) {
      return this.table["p_houdaogongxu"];
    },
    //切换中西封，尺寸的参数名称
    qiehuanfangshi() {
      if (this.table["p_daomo"]["data"][0].name.indexOf("标准刀模") >= 0) {
        let flag = false;
        for (
          let i = 2;
          i < this.table["p_houdaogongxu"]["data_after"].length;
          i++
        ) {
          if (this.table["p_houdaogongxu"]["data_after"][i]["data"][0].choose) {
            flag =
              flag ||
              this.table["p_houdaogongxu"]["data_after"][i]["data"][0].choose;
          }
        }
        if (flag) {
          this.table["p_xinfeng"]["container"] = "xfys";
        } else {
          let fs = 'xfys'
          if((this.table["p_cailiao"]["data_multi"][0].name === "双胶纸" || this.table["p_cailiao"]["data_multi"][0].name === "黄牛皮") && this.table["p_yinshuayanse"]["data"][0].choose){
            if(this.table["p_cailiao"]["data_multi"][1].name === "120克" && !this.table['p_yinshuashuliang']['data'][6].choose){
              fs = 'fangshi'
            }else if(this.table["p_cailiao"]["data_multi"][1].name === "100克" &&  (this.table["p_yinshuashuliang"]["data"][5].choose || this.table["p_yinshuashuliang"]["data"][4].choose)){
              fs = 'fangshi'
            }else if(this.table["p_yinshuashuliang"]["data"][6].choose && this.table["p_cailiao"]["data_multi"][1].name === "120克" && (this.table["p_yinshuashuliang"]["data"][6].value ==500 || this.table["p_yinshuashuliang"]["data"][6].value ==1000 ||this.table["p_yinshuashuliang"]["data"][6].value ==2000 ||this.table["p_yinshuashuliang"]["data"][6].value ==3000 ||this.table["p_yinshuashuliang"]["data"][6].value ==5000 ||this.table["p_yinshuashuliang"]["data"][6].value >=10000)){
              fs = 'fangshi'
            }else if(this.table["p_yinshuashuliang"]["data"][6].choose && this.table["p_cailiao"]["data_multi"][1].name === "100克" && (this.table["p_yinshuashuliang"]["data"][6].value ==5000 || this.table["p_yinshuashuliang"]["data"][6].value >=10000)){
              fs = 'fangshi'
            }
          }
          this.table["p_xinfeng"]["container"] = fs
        }
      } else {
        this.table["p_xinfeng"]["container"] = "xfys";
      }
    },
    // 整理参数
    func_tidyParams() {
      this.qiehuanfangshi()
      let result = {};
      if (this.table["p_daomo"]["data"][0].name.indexOf("标准刀模") >= 0) {
        let flag = false;
        for (
          let i = 2;
          i < this.table["p_houdaogongxu"]["data_after"].length;
          i++
        ) {
          if (this.table["p_houdaogongxu"]["data_after"][i]["data"][0].choose) {
            flag =
              flag ||
              this.table["p_houdaogongxu"]["data_after"][i]["data"][0].choose;
          }
        }
        if (flag) {
          console.log("标准产品专版报价设置result");
          result = {
        need_QQoffer: false, //需QQ另行计价
        string: "专版信封-", //报价内容
        hjg: [],
        SysCode: "Web",
        pid: 3914,
        byx: 2,
        sjlx: 2,
        hjgzdycount: 10,
        prh: "0", //常规印刷,精品印刷
        qid: 19,
        p: 0,
        jdgs: 10,
        hjgother: 1,
        gvip: null,
        tangJq: 0,
        zhiitemdj: 0,
        pzhiitemdj: 0,
        ZXid: 0,
        jpkezhong: 0,
        jphoudu: 1.45,
        jpdzx: 0,
        tban: 0,
        jban: 0,
        materialname: "",
        shuangmianjiaohen: 1,
        TJTB: 0,
        shuangmianjiaoCl: 15898,
        jtCl: 25548,
        JTTB: 0,
        jtJq: 0,
        moqieList: 3347,
        jpCl: 12,
        jpHd: 0.04,
        pzhiitemFangshi: 1,
        pzhiitemSel: -2,
        pjcailiao: 20672,
        pjyongzhi: 157,
        pjysys: 4,
        pjmoqieList: 3347,
        pjtangCl: 25552,
        pjTJTB: 0,
        pjtangJq: 0,
        pjjtCl: 25548,
        pjJTTB: 0,
        pjjtJq: 0,
        pjuvCl: 15898,
      }
        } else {
    if (!this.table["p_yinshuayanse"]["data"][0].choose) {
      console.log("非彩色");
      result = {
        need_QQoffer: false, //需QQ另行计价
        string: "专版信封-", //报价内容
        hjg: [],
        SysCode: "Web",
        pid: 3914,
        byx: 2,
        sjlx: 2,
        hjgzdycount: 10,
        prh: "0", //常规印刷,精品印刷
        qid: 19,
        p: 0,
        jdgs: 10,
        hjgother: 1,
        gvip: null,
        tangJq: 0,
        zhiitemdj: 0,
        pzhiitemdj: 0,
        ZXid: 0,
        jpkezhong: 0,
        jphoudu: 1.45,
        jpdzx: 0,
        tban: 0,
        jban: 0,
        materialname: "",
        shuangmianjiaohen: 1,
        TJTB: 0,
        shuangmianjiaoCl: 15898,
        jtCl: 25548,
        JTTB: 0,
        jtJq: 0,
        moqieList: 3347,
        jpCl: 12,
        jpHd: 0.04,
        pzhiitemFangshi: 1,
        pzhiitemSel: -2,
        pjcailiao: 20672,
        pjyongzhi: 157,
        pjysys: 4,
        pjmoqieList: 3347,
        pjtangCl: 25552,
        pjTJTB: 0,
        pjtangJq: 0,
        pjjtCl: 25548,
        pjJTTB: 0,
        pjjtJq: 0,
        pjuvCl: 15898,
      }
          } else {
      result = {
        need_QQoffer: false, //需QQ另行计价
        string: "专版信封-", //报价内容
        hjg: [],
        SysCode: "Web",
        pid: 3914,
        byx: 2,
        sjlx: 2,
        hjgzdycount: 10,
        prh: "0", //常规印刷,精品印刷
        qid: 19,
        p: 0,
        jdgs: 10,
        hjgother: 1,
        gvip: null,
        tangJq: 0,
        zhiitemdj: 0,
        pzhiitemdj: 0,
        ZXid: 0,
        jpkezhong: 0,
        jphoudu: 1.45,
        jpdzx: 0,
        tban: 0,
        jban: 0,
        materialname: "",
        shuangmianjiaohen: 1,
        TJTB: 0,
        shuangmianjiaoCl: 15898,
        jtCl: 25548,
        JTTB: 0,
        jtJq: 0,
        moqieList: 3347,
        jpCl: 12,
        jpHd: 0.04,
        pzhiitemFangshi: 1,
        pzhiitemSel: -2,
        pjcailiao: 20672,
        pjyongzhi: 157,
        pjysys: 4,
        pjmoqieList: 3347,
        pjtangCl: 25552,
        pjTJTB: 0,
        pjtangJq: 0,
        pjjtCl: 25548,
        pjJTTB: 0,
        pjjtJq: 0,
        pjuvCl: 15898,
      }
            if((this.table["p_cailiao"]["data_multi"][0].name === "双胶纸" || this.table["p_cailiao"]["data_multi"][0].name === "黄牛皮") && this.table["p_yinshuayanse"]["data"][0].choose){
              if(this.table["p_cailiao"]["data_multi"][1].name === "120克" && !this.table['p_yinshuashuliang']['data'][6].choose){
                result = {
                  need_QQoffer: false, //需QQ另行计价
                  string: "标准信封-", //报价内容
                  hjg: [],
                  api: "getprice1",
                };
              }else if(this.table["p_cailiao"]["data_multi"][1].name === "100克" &&  (this.table["p_yinshuashuliang"]["data"][5].choose || this.table["p_yinshuashuliang"]["data"][4].choose)){
                result = {
                  need_QQoffer: false, //需QQ另行计价
                  string: "标准信封-", //报价内容
                  hjg: [],
                  api: "getprice1",
                };
              }else if(this.table["p_yinshuashuliang"]["data"][6].choose && this.table["p_cailiao"]["data_multi"][1].name === "120克" && (this.table["p_yinshuashuliang"]["data"][6].value ==500 || this.table["p_yinshuashuliang"]["data"][6].value ==1000 ||this.table["p_yinshuashuliang"]["data"][6].value ==2000 ||this.table["p_yinshuashuliang"]["data"][6].value ==3000 ||this.table["p_yinshuashuliang"]["data"][6].value ==5000 ||this.table["p_yinshuashuliang"]["data"][6].value >=10000)){
                result = {
                  need_QQoffer: false, //需QQ另行计价
                  string: "标准信封-", //报价内容
                  hjg: [],
                  api: "getprice1",
                };
            } else if(this.table["p_yinshuashuliang"]["data"][6].choose && this.table["p_cailiao"]["data_multi"][1].name === "100克" && (this.table["p_yinshuashuliang"]["data"][6].value ==5000 || this.table["p_yinshuashuliang"]["data"][6].value >=10000)){
              result = {
                  need_QQoffer: false, //需QQ另行计价
                  string: "标准信封-", //报价内容
                  hjg: [],
                  api: "getprice1",
                };
            }
            }
          }
        }
      } else if (this.table["p_daomo"]["data"][0].name.indexOf("定制刀模") >= 0) {
        result = {
        need_QQoffer: false, //需QQ另行计价
        string: "专版信封-", //报价内容
        hjg: [],
        SysCode: "Web",
        pid: 3914,
        byx: 2,
        sjlx: 2,
        hjgzdycount: 10,
        prh: "0", //常规印刷,精品印刷
        qid: 19,
        p: 0,
        jdgs: 10,
        hjgother: 1,
        gvip: null,
        tangJq: 0,
        zhiitemdj: 0,
        pzhiitemdj: 0,
        ZXid: 0,
        jpkezhong: 0,
        jphoudu: 1.45,
        jpdzx: 0,
        tban: 0,
        jban: 0,
        materialname: "",
        shuangmianjiaohen: 1,
        TJTB: 0,
        shuangmianjiaoCl: 15898,
        jtCl: 25548,
        JTTB: 0,
        jtJq: 0,
        moqieList: 3347,
        jpCl: 12,
        jpHd: 0.04,
        pzhiitemFangshi: 1,
        pzhiitemSel: -2,
        pjcailiao: 20672,
        pjyongzhi: 157,
        pjysys: 4,
        pjmoqieList: 3347,
        pjtangCl: 25552,
        pjTJTB: 0,
        pjtangJq: 0,
        pjjtCl: 25548,
        pjJTTB: 0,
        pjjtJq: 0,
        pjuvCl: 15898,
      }
      }
      for (let i in this.table) {
        // 当前行
        const line_name = i;
        // 当前行类型
        let line_type = this.table[i]["data"]
          ? "data"
          : this.table[i]["data_multi"]
          ? "data_multi"
          : this.table[i]["data_after"]
          ? "data_after"
          : false;
        if (!line_type) return;
        const data = this.table[i][line_type];
        switch (line_type) {
          // 面板一(普通)
          case "data": {
            const container = this.table[i]["container"];
            if (this.table["p_daomo"]["data"][0].name.indexOf("标准刀模") >= 0) {
              if (!container) return;
              for (let j in data) {
                // 行中选中的块
                if (data[j]["choose"]) {
                  if (line_name === "p_yinshuashuliang") {
                    result["string"] += data[j]["value"] + "个-";
                  } else if (line_name === "p_kuanshu") {
                    result["string"] += data[j]["value"] + "款-";
                  } else {
                    result["string"] += data[j]["name"] + "-";
                  }
                  // 常规处理
                  if (container.constructor["name"] === "String") {
                    result[container] = data[j]["value"];
                  } else if (container.constructor["name"] === "Array") {
                    for (let c in container) {
                      result[container[c]] = data[j]["value"][c];
                    }
                  }
                  break;
                }
              }
            } else if (this.table["p_daomo"]["data"][0].name.indexOf("定制刀模") >= 0) {
              for (let j in data) {
                // 行中选中的块
                if (data[j]["choose"]) {
                  // 文字内容提示
                  if (line_name === "p_yinshuashuliang") {
                    result["string"] += data[j]["value"] + "个-";
                  } else if (line_name === "p_kuanshu") {
                    result["string"] += data[j]["value"] + "款-";
                  } else if (
                    line_name === "p_chengpinchicun" &&
                    data[j]["type"] === "custom2"
                  ) {
                    const x = data[j]["value"][0];
                    const y = data[j]["value"][1];
                    result["string"] += data[j]["name"] + x + "×" + y + "-";
                  } else {
                    result["string"] += data[j]["name"] + "-";
                  }

                  // 另行处理
                  if (
                    i === "p_chengpinchicun" &&
                    data[j]["type"] === "custom2"
                  ) {
                    const x = data[j]["value"][0];
                    const y = data[j]["value"][1];
                    this.table[i][line_type][j]["value"][2] = x + "*" + y;
                    this.table[i][line_type][j]["value"][3] =
                      "展开尺寸:" + x + "×" + y;
                  }

                  // 常规处理
                  if (container.constructor["name"] === "String") {
                    result[container] = data[j]["value"];
                  } else if (container.constructor["name"] === "Array") {
                    for (let c in container) {
                      result[container[c]] = data[j]["value"][c];
                    }
                  }
                  break;
                }
              }
            }
            break;
          }
          // 面板二(多行)
          case "data_multi": {
            const container = this.table[i]["container"];
            if (this.table["p_daomo"]["data"][0].name.indexOf("标准刀模") >= 0) {
              if (!container) return;
            }
            for (let c in container) {
              // 文字内容提示
              result["string"] += data[c]["name"] + "-";
              result[container[c]] = data[c]["value"];
            }
            break;
          }
          // 面板二(后道工序)
          case "data_after": {
            for (let j in data) {
              const in_data = data[j]["data"];
              for (let k in in_data) {
                if (in_data[k]["choose"]) {
                  // 文字内容提示
                  if (this.table["p_daomo"]["data"][0].name.indexOf("标准刀模") >= 0) {
                    result["string"] += in_data[k]["name"] + "-";
                    const container = data[j]["container"];
                    if (!container) return;
                    if (container === "hjg") {
                      result["hjg"].push(in_data[k]["value"]);
                    } else if (container.constructor["name"] === "String") {
                      result[container] = in_data[k]["value"];
                    } else if (container.constructor["name"] === "Array") {
                      for (let c in container) {
                        if (container[c] === "hjg") {
                          result["hjg"].push(in_data[k]["value"][c]);
                        } else {
                          result[container[c]] = in_data[k]["value"][c];
                        }
                      }
                    }
                    break;
                  } else if (this.table["p_daomo"]["data"][0].name.indexOf("定制刀模") >= 0) {
                    if (
                      in_data[k]["name"] === "开窗贴膜" ||
                      in_data[k]["name"] === "烫金/银" ||
                      in_data[k]["name"] === "击凸"
                    ) {
                      const x = in_data[k]["value"][0];
                      const y = in_data[k]["value"][1];
                      result["string"] +=
                        in_data[k]["name"] + x + "×" + y + "-";
                    } else if (
                      in_data[k]["name"].substring(0, 1) === "烫" &&
                      in_data[k]["custom2"]
                    ) {
                      const x = in_data[k]["value"][0];
                      const y = in_data[k]["value"][1];
                      result["string"] +=
                        in_data[k]["name"] +
                        x +
                        "×" +
                        y +
                        in_data[k]["unit"] +
                        "-";
                    } else {
                      result["string"] += in_data[k]["name"] + "-";
                    }

                    const container = data[j]["container"];

                    if (container === "hjg") {
                      result["hjg"].push(in_data[k]["value"]);
                    } else if (container.constructor["name"] === "String") {
                      result[container] = in_data[k]["value"];
                    } else if (container.constructor["name"] === "Array") {
                      for (let c in container) {
                        if (container[c] === "hjg") {
                          result["hjg"].push(in_data[k]["value"][c]);
                        } else {
                          result[container[c]] = in_data[k]["value"][c];
                        }
                      }
                    }
                    break;
                  }
                }
              }
            }
            break;
          }
          default:
            return;
        }
      }
      if (this.table["p_daomo"]["data"][0].name.indexOf("标准刀模") >= 0) {
        let flag = false;
        for (
          let i = 2;
          i < this.table["p_houdaogongxu"]["data_after"].length;
          i++
        ) {
          if (this.table["p_houdaogongxu"]["data_after"][i]["data"][0].choose) {
            flag =
              flag ||
              this.table["p_houdaogongxu"]["data_after"][i]["data"][0].choose;
          }
        }
        if (flag) {
          console.log("标准产品专版报价设置pidd");
          this.pidd = "pidenv_lsf";
        } else {
          if (!this.table["p_yinshuayanse"]["data"][0].choose) {
            this.pidd = "pidenv_lsf";
            } else {
              this.pidd = 'pidenv_lsf'
              if((this.table["p_cailiao"]["data_multi"][0].name === "双胶纸" || this.table["p_cailiao"]["data_multi"][0].name === "黄牛皮") && this.table["p_yinshuayanse"]["data"][0].choose){
                if(this.table["p_cailiao"]["data_multi"][1].name === "120克" && !this.table['p_yinshuashuliang']['data'][6].choose){
                  this.pidd = "pidenv_xf";
                }else if(this.table["p_cailiao"]["data_multi"][1].name === "100克" &&  (this.table["p_yinshuashuliang"]["data"][5].choose || this.table["p_yinshuashuliang"]["data"][4].choose)){
                  this.pidd = "pidenv_xf";
                }else if(this.table["p_yinshuashuliang"]["data"][6].choose && this.table["p_cailiao"]["data_multi"][1].name === "120克" && (this.table["p_yinshuashuliang"]["data"][6].value ==500 || this.table["p_yinshuashuliang"]["data"][6].value ==1000 ||this.table["p_yinshuashuliang"]["data"][6].value ==2000 ||this.table["p_yinshuashuliang"]["data"][6].value ==3000 ||this.table["p_yinshuashuliang"]["data"][6].value ==5000 ||this.table["p_yinshuashuliang"]["data"][6].value >=10000)){
                this.pidd = 'pidenv_xf'
            } else if(this.table["p_yinshuashuliang"]["data"][6].choose && this.table["p_cailiao"]["data_multi"][1].name === "100克" && (this.table["p_yinshuashuliang"]["data"][6].value ==5000 || this.table["p_yinshuashuliang"]["data"][6].value >=10000)){
              this.pidd = 'pidenv_xf'
            }
              }
          }
        }
      } else if (this.table["p_daomo"]["data"][0].name.indexOf("定制刀模") >= 0) {
        this.pidd = "pidenv_lsf";
      }
      if (this.table["p_daomo"]["data"][0].name.indexOf("标准刀模") >= 0) {
        let flag = false;
        for (
          let i = 2;
          i < this.table["p_houdaogongxu"]["data_after"].length;
          i++
        ) {
          if (this.table["p_houdaogongxu"]["data_after"][i]["data"][0].choose) {
            flag =
              flag ||
              this.table["p_houdaogongxu"]["data_after"][i]["data"][0].choose;
          }
        }
        if (flag) {
          console.log("标准产品专版报价设置材料名称");
        } else {
          if (this.table["p_yinshuayanse"]["data"][0].choose
        ) {
            if (
              result.cailiao === "5" &&
              result.yongzhi === 120 &&
              (result.shuliang == 500 || result.shuliang == 1000 || result.shuliang == 2000|| result.shuliang == 3000|| result.shuliang == 5000|| result.shuliang >= 10000)
            ) {
              result.cailiao = "120克双胶纸";
              delete result["yongzhi"];
            } else if (
              result.cailiao === "5" &&
              result.yongzhi === 100 &&
              (result.shuliang ==5000 || result.shuliang >= 10000)
            ) {
              result.cailiao = "100克双胶纸";
              delete result["yongzhi"];
            } else if (
              result.cailiao === "9" &&
              result.yongzhi === 120 && 
              (result.shuliang == 500 || result.shuliang == 1000 || result.shuliang == 2000|| result.shuliang == 3000|| result.shuliang == 5000|| result.shuliang >= 10000)
            ) {
              result.cailiao = "120克牛皮纸";
              delete result["yongzhi"];
            } else if (
              result.cailiao === "9" &&
              result.yongzhi === 100 &&
              (result.shuliang ==5000 || result.shuliang >= 10000)
            ) {
              result.cailiao = "100克牛皮纸";
              delete result["yongzhi"];
            }
          }
        }
      }
      if (result["string"].endsWith("-")) {
        result["string"] = result["string"].substring(
          0,
          result["string"].length - 1
        );
      }
      
      if (this.table["p_daomo"]["data"][0].name.indexOf("定制刀模") >= 0) {
        if (result.hjgzdy3 && result.hjgzdy3 == 4587) {
          delete result.hjgzdy2;
        }
        if (result.hjgzdy2 && result.hjgzdy2 == 4586) {
          delete result.hjgzdy3;
        }
        // if(result.hjg[2] == '定制刀模'){
        //   delete result.hjg[2]
        // }
      }
      if (result.string.indexOf("自定义展开尺寸") >= 0) {
        result.isdiy = 1;
      }
      if (this.pidd == "pidenv_xf") {
        result.chichunstr = result.chichun;
      } else {
        result.chichun = result.xx + "x" + result.yy;
      }
      result.materialname = this.table.p_cailiao.data_multi[0].name;
      return result;
    },
  },
  mounted() {},
};
</script>
<style src='@/style/orderProduct.css'></style>



// WEBPACK FOOTER //
// src/pages/order/v2020/xinfeng.vue